import {
  AddressInput,
  DatePicker,
  InputText,
  InputTextArea,
  PhoneNumberField,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { AddressDetails } from "../../components/AddressInput";
import FileUploader from "../../components/ContactService/FileUploader";
import { connect, useDispatch } from "react-redux";
import { uploadImage } from "../../store/contact-service/actions";
import { RootState } from "../../store/root-reducer";

function PurchaseDetails({ documents }) {
  const { control, setValue } = useFormContext();
  const dispatch = useDispatch();

  return (
    <div className="space-y-3">
      <FileUploader
        control={control}
        name="invoiceImage"
        label="Invoice Document/Image"
        uploadedFiles={documents.invoice}
        onFileSelect={(files) =>
          dispatch(uploadImage({ fieldName: "invoice", files }))
        }
        note="The invoice or receipt should show the purchase of a MyProtectAll protection plan."
        required
        minFile={1}
      />
      <InputText
        control={control}
        name="purchaseDetails.invoice"
        required
        label="Invoice Number"
      />
      <DatePicker
        control={control}
        name="purchaseDetails.date_of_purchase"
        required
        placeholder="Date of Purchase"
        label="Date of Purchase"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_name"
        required
        label="Store Name"
      />
      <PhoneNumberField
        control={control}
        name="purchaseDetails.store_phone"
        required
        label="Store Phone"
      />
      <AddressInput
        control={control}
        name="purchaseDetails.store_address"
        onAddressSelect={(address: AddressDetails) => {
          setValue("purchaseDetails.store_city", address.city);
          setValue("purchaseDetails.store_state", address.state);
          setValue("purchaseDetails.store_zip", address.zipCode);
        }}
        required
        label="Store Address"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_city"
        required
        label="Store City"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_state"
        required
        label="Store State"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_zip"
        required
        label="Store Zip code"
      />
      <InputTextArea
        control={control}
        name="purchaseDetails.were_any_items_exchanged"
        required
        label="Were any items exchanged"
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  documents: state?.contactService?.documents || {},
});

export default connect(mapStateToProps)(PurchaseDetails);
